module.exports = __webpack_public_path__ + "static/img/Mobile-Devices-Pink-Hue.4aeed26c.jpg";